export default __webpack_public_path__ + "static/media/bt.8da9bc35.png";